import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { useTeamData } from "./hooks/use-team-data";
import { TeamHeader } from "./components/team-header/team-header";
import { TeamPercentiles } from "./components/team-percentiles/team-percentiles";
import { TeamContent } from "./components/team-content/team-content";
import { TabNavigation } from "../../components/shared/tab-navigation/tab-navigation";
import { LoadingState, ErrorState } from "../../components/shared/page-states/page-states";

export const TeamPage = () => {
  const { teamId } = useParams();
  const {
    teamData,
    games,
    isLoading,
    isHeaderReady,
    setIsHeaderReady,
    error,
    activeTab,
    setActiveTab,
    statData,
    availableTabs,
  } = useTeamData(teamId);

  const handleTabChange = useCallback((newTab) => setActiveTab(newTab), [setActiveTab]);

  if (isLoading) return <LoadingState />;
  if (error) return <ErrorState error={error} title="Error Loading Team" />;
  if (!teamData) return null;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 relative overflow-hidden">
      <div className="relative z-10 container max-w-6xl mx-auto px-8 sm:px-12 lg:px-16 py-16">
        {!isHeaderReady && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/70 backdrop-blur-sm">
            <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin" />
          </div>
        )}

        <div className="space-y-6">
          <div className="grid grid-cols-1 lg:grid-cols-[3fr_5fr] gap-6">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200">
              <TeamHeader teamData={teamData} onReady={() => setIsHeaderReady(true)} />
            </div>
            <div className="bg-white rounded-xl shadow-sm border border-gray-200">
              <TeamPercentiles teamId={teamData.team_id} years={teamData.years_played} />
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200">
            <TabNavigation activeTab={activeTab} onTabChange={handleTabChange} availableTabs={availableTabs} />
            <TeamContent
              activeTab={activeTab}
              teamData={teamData}
              games={games}
              teamId={teamData.team_id}
              years={teamData.years_played}
              statData={statData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
